var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.5C24.0081 30.5 30.5 24.0081 30.5 16C30.5 7.99187 24.0081 1.5 16 1.5C7.99187 1.5 1.5 7.99187 1.5 16C1.5 24.0081 7.99187 30.5 16 30.5Z",
    fill: "#6D6E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5Z",
    fill: "#58595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0725 1.5C16.2344 2.16059 16.3497 2.83174 16.4175 3.5085C18.726 3.58544 20.968 4.30049 22.8948 5.57431C24.8215 6.84812 26.3577 8.63088 27.3327 10.7248C28.3078 12.8186 28.6836 15.1417 28.4185 17.4362C28.1534 19.7307 27.2578 21.9069 25.8309 23.7233C24.4041 25.5396 22.5019 26.9251 20.3355 27.726C18.169 28.527 15.823 28.7119 13.5578 28.2604C11.2926 27.809 9.19674 26.7387 7.50288 25.1684C5.80903 23.598 4.5834 21.5891 3.96199 19.3645C3.31176 19.4535 2.65628 19.4988 1.99999 19.5C1.97549 19.5 1.94999 19.5 1.92749 19.5C2.58271 22.1341 3.96411 24.5313 5.91453 26.419C7.86495 28.3067 10.3061 29.6091 12.9601 30.1779C15.6142 30.7467 18.3746 30.5591 20.9273 29.6365C23.48 28.7139 25.7225 27.0933 27.3996 24.9591C29.0768 22.8249 30.1212 20.2628 30.414 17.5643C30.7069 14.8658 30.2365 12.1393 29.0562 9.69501C27.876 7.2507 26.0334 5.18675 23.738 3.73798C21.4427 2.28922 18.7868 1.51381 16.0725 1.5Z",
    fill: "#58595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 28.5C19.2638 28.4772 22.3893 27.1787 24.7084 24.882C27.0276 22.5853 28.3564 19.4726 28.4109 16.2091C28.4654 12.9456 27.2413 9.79026 25.0002 7.41737C22.7591 5.04448 19.6787 3.6423 16.4174 3.5105C16.4704 4.00525 16.498 4.50241 16.4999 5C16.4994 8.5054 15.229 11.8919 12.9239 14.5328C10.6188 17.1737 7.43508 18.8902 3.96191 19.3645C4.69635 21.9924 6.2705 24.3078 8.44408 25.9574C10.6177 27.6069 13.2713 28.4998 15.9999 28.5Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19H11.5L9 22H20.5L23 19Z",
    fill: "#424EDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5L20.5 14.5H9L11.5 17.5H23Z",
    fill: "#2488FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10H11.5L9 13H20.5L23 10Z",
    fill: "#00DDC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.5013ceb12488e656e948a7e1b16d35e5.svg";
export { ForwardRef as ReactComponent };